import { ActivityIndicator, Dimensions, Platform, StyleSheet, Text, View } from 'react-native'
import React, { useEffect, useRef, useState } from 'react'
import { ThemedView } from '@app/theme'
import WebView from 'react-native-webview'
import { checkDigioMandateStatusTataApi } from '../digioMandateSignService'
import { useAppDispatch, useAppSelector } from '@app/store/hooks'
import handleApiErr from '@app/helper/handleApiErr'
import { showErrorSheet } from '@app/store/slices/errorSlice'
import { TATA_MANDATE_STATUS } from '@app/screens/DigioAutoPayProgress/DigioAutoPayProgress'
import { updateLinkedApplication } from '@app/store/slices/authSlice'
import AsyncStorage from '@react-native-async-storage/async-storage'
import axios from 'axios'
import { endpoints } from '@app/api/apis'


const renewApplicationApi = async (payload: { applicationId: string }) => {

  let applicationId = payload.applicationId;
  let applicationIdStored = await AsyncStorage.getItem('application_id')

  if (applicationIdStored) {
      applicationId = applicationIdStored;
  }

  const response = await axios.get(endpoints.renewAppliction + applicationId);
  return response.data;

}

const TataMandateModal = ({ mandateLink , onSuccess , onError }: { mandateLink: string , onSuccess : () => void , onError:() => void}) => {

        const applicationId  = useAppSelector(state => state.auth?.userDetails?.linkedApplications[0]?.applicationId)
        const dispatch = useAppDispatch()
        const tataMandateInterval = useRef<NodeJS.Timeout | null>(null);

        const [pollerFinish , setPollerFinish] = useState(false)



    const runPollarTataMandate = async () => {
        try {
            const response = await checkDigioMandateStatusTataApi({ applicationId: applicationId })
            const status = response?.data?.stepResponseObject?.status?.toUpperCase()?.trim()

            if (status !== TATA_MANDATE_STATUS.IN_PROGRESS?.toUpperCase()?.trim()) {
                tataMandateInterval && clearInterval(tataMandateInterval?.current as NodeJS.Timeout);
                  const renewAppliationResponse = await renewApplicationApi({ applicationId: applicationId });
                    dispatch(updateLinkedApplication(renewAppliationResponse));
                    onSuccess()
            }
        } catch (error: any) {
            if (handleApiErr(error)) {
                onError()
                dispatch(showErrorSheet({
                    isErrorSheetVisible: true,
                    errorMessage: error?.data?.message,
                    closeOnBackdropPress: true,
                    errorType: error?.data?.voltErrorCode || error?.data?.statusCode,
                    showErrorHeading: true,
                    errorHeading: error?.data?.header,
                    btnName: 'Go back',
                }))
            }
        }
    }



    useEffect(() => {
        tataMandateInterval.current = setInterval(runPollarTataMandate, 5000);
        return () => {
          if (tataMandateInterval.current) {
            clearInterval(tataMandateInterval.current);
          }
        };
      }, []);




    const [loading , setLoading] = useState(true)


   
    return (
        <ThemedView height={Dimensions.get('screen').height - 120} pt='2xl' borderTopLeftRadius='lg' borderTopRightRadius='lg' overflow='hidden' minHeight={'100%'}>
            {loading && <ActivityIndicator style={{position : 'absolute' , top : 200 , right : 200 , zIndex : 10}} />}
            <WebView style={{ flex: 1 , marginTop : 10 , opacity : pollerFinish ? 0 : 1 }} source={{ uri: mandateLink }}
                javaScriptEnabled={true}
                domStorageEnabled={true}
                originWhitelist={['*']}
                automaticallyAdjustContentInsets={false}
                onLoad={() => {
                    setLoading(false)
                }}
                onNavigationStateChange={(navState) => {
                    // this means that the tata website is closed
                    if(navState.url.includes('voltmoney.in/tata/webhook/mandate')) {
                        setPollerFinish(true)
                    }
                }}
                useWebKit={true}
                allowsInlineMediaPlayback
                mediaPlaybackRequiresUserAction={false}
                javaScriptEnabledAndroid
                showsHorizontalScrollIndicator={false}
                nestedScrollEnabled={Platform.OS !== "web"}
                scalesPageToFit={false}
                scrollEnabled={Platform.OS === "ios"}
                injectedJavaScript={`
           $('form:first').css('max-width', '100%');
           $('form:first').css('width', '100%');
           $('div:first').removeClass("wrapper");
           $('form:first').css('position', 'unset');
           $('form:first').css('padding-bottom', '100%');
           $('body').scrollTop({0});`
                }
            />
        </ThemedView>
    )
}

export default TataMandateModal

const styles = StyleSheet.create({})